import React, { useState, useEffect, useContext } from 'react';
import { getCustomers, getInvoiceNumber, ListSalesOrder, postGeneralData, ProductReturn, UpdatePaymentComplete } from '../../../Utility/Api';
import './style.css';
import { toast } from "react-toastify";
import { WarehouseContext } from '../../../Utility/UserContext';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { getFormattedCurrentDate2, onReqCreatePayment } from '../../../Utility/function';

const Return = () => {
  const [unqui, setunqui] = useState();
  const [customers, setCustomers] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [orders, setOrders] = useState([]);
  const [returnReason, setReturnReason] = useState('');
  const [searchCustomerTerm, setSearchCustomerTerm] = useState('');
  const [productSearchTerm, setProductSearchTerm] = useState('');
  const { showLoader, hideLoader, shopItem, UserItem } = useContext(WarehouseContext);
  const [user, setuser] = useState(UserItem);

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [availableSerials, setAvailableSerials] = useState([]);
  const [selectedSerials, setSelectedSerials] = useState([]);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const fetchCustomers = async () => {
      showLoader();
      try {
        const res = await getCustomers();
        // setCustomers([{ name: "All" }, ...res.data?.data] || []);
        setCustomers(res.data?.data || []);
      } catch (err) {
        toast.error('Failed to load customers');
      } finally {
        hideLoader();
      }
    };
    fetchCustomers();
    fetchInvoiceNumber();
  }, []);

  const fetchInvoiceNumber = async () => {
    try {
      const response = await getInvoiceNumber(4);
      if (response.data?.invoice_no) {
        setunqui(response.data.invoice_no);
      }
    } catch (error) {
      console.error('Error fetching invoice number:', error);
    }
  };

  const fetchOrders = async () => {
    showLoader();
    try {
      const res = await ListSalesOrder(selectedCustomerId, shopItem?.shop_id);
      setOrders(res.data?.data || []);
      const customer = customers.find(c => c.customer_id === selectedCustomerId);
      setSelectedCustomer(customer || null);
    } catch (err) {
      toast.error('Failed to load orders');
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    if (selectedCustomerId) {
      fetchOrders();
    } else {
      setOrders([]);
      setSelectedCustomer(null);
    }
  }, [selectedCustomerId, customers]);

  const role = user?.role_title?.toLowerCase();
  if (role !== "super admin" && role !== "admin") {
    return (
      <div className="alert alert-danger m-5 text-center shadow-sm">
        <h4 className="fw-bold text-danger">Access Denied</h4>
        <p className="mb-0">Only Super Admin is authorized to access the Sales Return module.</p>
      </div>
    );
  }

  const filteredCustomers = searchCustomerTerm
    ? customers.filter(c => c.status !== 1 && c.name.toLowerCase().includes(searchCustomerTerm.toLowerCase()))
    : customers.filter(c => c.status !== 1);

  const handleCustomerChange = (id, name) => {
    setSelectedCustomerId(id);
    setSearchCustomerTerm(name);
    setOrders([]);
    setReturnReason('');
    setProductSearchTerm('');
  };

  const filteredOrders = productSearchTerm
    ? orders.filter(o =>
      o.product_name?.toLowerCase().includes(productSearchTerm?.toLowerCase()) ||
      o.unique_id?.toLowerCase().includes(productSearchTerm?.toLowerCase())
    )
    : orders;

  // Add this at the beginning of your openReturnModal function
  const openReturnModal = (product) => {
    try {
      const serials = JSON.parse(product.serial_number || "[]");
      // Parse the overall_discount if it exists
      const productWithParsedDiscount = {
        ...product,
        overall_discount: product.overall_discount ? JSON.parse(product.overall_discount) : null
      };

      setAvailableSerials(serials.filter(s => s.status !== "1"));
      setSelectedSerials([]);
      setSelectedProduct(productWithParsedDiscount); // Use the parsed version
      setShowModal(true);
    } catch (e) {
      console.error('Error parsing data:', e);
      toast.error('Error loading product details');
    }
  };

  const handleSerialSelect = (serial) => {
    console.log("selected Serials", serial)
    setSelectedSerials([...selectedSerials, serial]);
    setAvailableSerials(availableSerials.filter(s => s.serial_number !== serial.serial_number));
  };

  const handleSerialRemove = (serial) => {
    setSelectedSerials(selectedSerials.filter(s => s.serial_number !== serial.serial_number));
    setAvailableSerials([...availableSerials, serial]);
  };

  // Calculate discounted price for a single serial
  // In your calculateItemReturnPrice function
  const calculateItemReturnPrice = (serial) => {
    const basePrice = parseFloat(serial.selling_price || selectedProduct?.sales_price || 0);
    let discountedPrice = basePrice;

    // Apply item-level discount if exists
    if (selectedProduct?.discount) {
      if (selectedProduct.discount_type === "1") { // Percentage
        discountedPrice = basePrice * (1 - (parseFloat(selectedProduct.discount) / 100));
      } else { // Fixed amount
        discountedPrice = basePrice - parseFloat(selectedProduct.discount);
      }
    }

    // Apply overall order discount if exists and has value > 0
    if (selectedProduct?.overall_discount && parseFloat(selectedProduct.overall_discount.value) > 0) {
      if (selectedProduct.overall_discount.type === "%") {
        discountedPrice = discountedPrice * (1 - (parseFloat(selectedProduct.overall_discount.value)) / 100);
      } else { // Fixed amount (distribute proportionally)
        const totalOrderValue = parseFloat(selectedProduct.price_total);
        const itemProportion = basePrice / totalOrderValue;
        discountedPrice = discountedPrice - (parseFloat(selectedProduct.overall_discount.value) * itemProportion);
      }
    }

    return discountedPrice;
  };

  // Calculate total return amount with discounts
  const calculateReturnAmount = () => {
    return selectedSerials.reduce((total, serial) => {
      return total + calculateItemReturnPrice(serial);
    }, 0);
  };

  const calculateDueAmount = () => {
    return parseFloat(selectedProduct?.remaining || 0);
  };

  const calculateFinancials = () => {
    const returnAmount = calculateReturnAmount();
    const dueAmount = calculateDueAmount();

    if (returnAmount <= dueAmount) {
      return {
        refundAmount: 0,
        creditAdjustment: returnAmount,
        newBalance: dueAmount - returnAmount
      };
    } else {
      return {
        refundAmount: returnAmount - dueAmount,
        creditAdjustment: dueAmount,
        newBalance: 0
      };
    }
  };

  const handleReturnSubmit = async (type) => {
    if (selectedSerials.length === 0) {
      toast.error("Please select at least one serial number to return");
      return;
    }

    showLoader();
    try {
      const financials = calculateFinancials();
      const purchasePrice = selectedSerials.reduce((total, serial) => {
        return total + parseFloat(serial?.purchase_price || 0);
      }, 0)

      const detailedReturnSerials = selectedSerials.map(serial => ({
        ...serial,
        original_price: parseFloat(serial.selling_price || selectedProduct?.sales_price || 0),
        item_discount: serial.discount
          ? {
            type: selectedProduct.discount_type === "1" ? "%" : "INR",
            value: serial.discount
          }
          : null,
        overall_discount: selectedProduct.overall_discount || null,
        final_return_price: calculateItemReturnPrice(serial)
      }));

      const returnData = {
        ...selectedProduct,
        customer_name: selectedCustomer?.name || "",
        return_serial_number: JSON.stringify(detailedReturnSerials),
        serial_number: JSON.stringify(availableSerials),
        returnqty: selectedSerials.length,
        return_amount: financials.refundAmount.toFixed(2),
        credit_adjustment: financials.creditAdjustment.toFixed(2),
        transaction_type: financials.refundAmount > 0 ? "refund" : "credit_adjustment",
        original_total: selectedSerials.reduce((sum, serial) =>
          sum + parseFloat(serial.selling_price || selectedProduct?.sales_price || 0), 0),
        discounted_total: calculateReturnAmount(),
        applied_discounts: {
          item_discounts: selectedSerials.map(serial => ({
            serial: serial.serial_number,
            discount: serial.discount,
            type: selectedProduct.discount_type === "1" ? "%" : "INR"
          })),
          overall_discount: selectedProduct.overall_discount || null
        }
      };

      if (calculateDueAmount() > 0) {
        const paydata = {
          orderID: selectedProduct?.unique_id,
          date: getFormattedCurrentDate2(),
          amount: "0",
          total_amount: selectedProduct.price_total,
          cash: financials.creditAdjustment,
          credit: financials.newBalance || "0",
          card: 0,
          type: 5,
          mop: "1",
          complete: financials.newBalance > 0 ? "0" : "1",
        };

        await onReqCreatePayment(paydata);

        try {
          const generalDataPayload = {
            type: "5",
            ref_id: selectedProduct?.unique_id,
            remarks: "Sales - Credit Adjustment",
            date: getFormattedCurrentDate2(),
            created_by: user?.user_id,
            shop_id: shopItem?.id || "0",
            amount: paydata?.cash,
            is_debit: "1",
            profitloss: paydata?.complete == "1" ? selectedProduct?.supplier_id : "",
          };
          await postGeneralData(generalDataPayload);

          if (paydata?.complete == "0") {
            const generalDataPayload = {
              type: "8",
              ref_id: selectedProduct?.unique_id,
              remarks: "Sales Credit",
              date: getFormattedCurrentDate2(),
              created_by: user?.user_id,
              shop_id: shopItem?.id || "0",
              amount: paydata.credit,
              is_debit: "1",
              profitloss: "",
            };
            await postGeneralData(generalDataPayload);
          } else {
            const paymentCompleted = {
              type: "8",
              shop_id: shopItem?.id || "0",
              ref_id: selectedProduct?.unique_id,
            }
            await UpdatePaymentComplete(paymentCompleted);
          }
        } catch (e) {
          console.error("General log failed:", e);
          toast.error("Failed to create general transaction log");
        }
      }

      const payload = {
        serial_number: JSON.stringify(selectedSerials.map(s => s.serial_number)),
        invoice_number: JSON.stringify([{
          unique_id: selectedProduct.unique_id,
          serial_number: selectedSerials.map(s => s.serial_number),
          product_name: selectedProduct.product_name,
          original_price: selectedProduct.sales_price,
          discounted_price: calculateReturnAmount() / selectedSerials.length,
          discount_details: {
            item_discount: selectedProduct.discount_type === "1" ?
              `${selectedProduct.discount}%` :
              `${selectedProduct.discount} INR`,
            overall_discount: selectedProduct.overall_discount ?
              `${selectedProduct.overall_discount.value} ${selectedProduct.overall_discount.type}` :
              null
          }
        }]),
        amount: financials.refundAmount.toFixed(2),
        credit_adjustment: financials.creditAdjustment.toFixed(2),
        remaining: type == "credit" ? financials.refundAmount.toFixed(2) : 0,
        sales_update: JSON.stringify([{
          id: selectedProduct.id,
          serial_number: [...availableSerials, ...selectedSerials.map(s => ({ ...s, status: "1" }))]
        }]),
        unique_id: unqui,
        user_id: user?.user_id || "",
        shop_id: String(shopItem?.id || ""),
        type: "0",
        return_data: JSON.stringify([returnData]),
        status: type == "credit" ? 1 : 0
      };

      await ProductReturn(payload);

      if (purchasePrice) {
        try {
          const cogsPayload = {
            type: "4",
            ref_id: unqui,
            remarks: "COGS To Inventory",
            date: getFormattedCurrentDate2(),
            created_by: user?.user_id,
            shop_id: shopItem?.id || "0",
            amount: purchasePrice,
            is_debit: "0",
          };
          await postGeneralData(cogsPayload);

          const inventoryPayload = {
            type: "3",
            ref_id: unqui,
            remarks: "Inventory From COGs",
            date: getFormattedCurrentDate2(),
            created_by: user?.user_id,
            shop_id: shopItem?.id || "0",
            amount: purchasePrice,
            is_debit: "1",
          };
          await postGeneralData(inventoryPayload);
        } catch (error) {
          console.error("Purchase price error:", error);
        }
      }

      if (financials.refundAmount > 0) {
        const generalPayload = {
          type: "5",
          ref_id: unqui,
          remarks: returnReason || `Sales Return (Refund: ${financials.refundAmount.toFixed(2)})`,
          date: new Date().toISOString().split("T")[0],
          created_by: user?.user_id,
          shop_id: shopItem?.shop_id || "0",
          amount: financials.refundAmount.toFixed(2),
          is_debit: "1"
        }
        await postGeneralData(generalPayload);

        const bankPayload = {
          type: "2",
          ref_id: unqui,
          remarks: "Bank - Sales Return Refund",
          date: getFormattedCurrentDate2(),
          created_by: user?.user_id,
          shop_id: shopItem?.id || "0",
          amount: financials.refundAmount.toFixed(2),
          is_debit: "0",
        };

        const payablePayload = {
          type: "12",
          ref_id: unqui,
          remarks: "Sales Return Credit",
          date: getFormattedCurrentDate2(),
          created_by: user?.user_id,
          shop_id: shopItem?.id || "0",
          amount: financials.refundAmount.toFixed(2),
          is_debit: "0",
        };
        if (type == "credit") {
          await postGeneralData(payablePayload);
        } else {
          await postGeneralData(bankPayload);
          var paydata = {
            orderID: unqui,
            date: getFormattedCurrentDate2(),
            amount: financials.refundAmount,
            total_amount: financials.refundAmount,
            cash: financials.refundAmount,
            credit: 0,
            card: 0,
            type: 5,
            mop: "1",
            complete: "1",
          };

          await onReqCreatePayment(paydata);
        }
      }

      const successMessage = (
        <div>
          <p>Return processed successfully</p>
          <p>Items Returned: {selectedSerials.length}</p>
          <p>Original Total: {returnData.original_total.toFixed(2)}</p>

          {/* Item Discounts */}
          {selectedProduct?.discount && parseFloat(selectedProduct.discount) > 0 && (
            <p className="text-info">
              Item Discounts Applied: -{(
                returnData.original_total -
                selectedSerials.reduce((sum, serial) => {
                  const basePrice = parseFloat(serial.selling_price || selectedProduct?.sales_price || 0);
                  return sum + (
                    selectedProduct.discount_type === "1" ?
                      (basePrice * (parseFloat(selectedProduct.discount) / 100)) :
                      parseFloat(selectedProduct.discount)
                  );
                }, 0)
              ).toFixed(2)}
              {selectedProduct.discount_type === "1" ? ` (${selectedProduct.discount}%)` : ' (INR)'}
            </p>
          )}

          {/* Overall Discount */}
          {selectedProduct?.overall_discount && parseFloat(selectedProduct.overall_discount.value) > 0 && (
            <p className="text-info">
              Overall Discount Applied: -{selectedProduct.overall_discount.value} {selectedProduct.overall_discount.type}
            </p>
          )}

          <p>Total Return Value: {calculateReturnAmount().toFixed(2)}</p>

          {financials.creditAdjustment > 0 && (
            <p className="text-info">
              Credit Adjustment: -{financials.creditAdjustment.toFixed(2)}
            </p>
          )}

          {financials.refundAmount > 0 && (
            <p className="text-success">
              Refund Issued: +{financials.refundAmount.toFixed(2)}
            </p>
          )}

          <p>New Credit Balance: {financials.newBalance.toFixed(2)}</p>
        </div>
      );

      toast.success(successMessage);
      setShowModal(false);
      fetchInvoiceNumber();
      fetchOrders();
    } catch (error) {
      console.error("Return error:", error);
      toast.error(error.message || "Error processing return");
    } finally {
      hideLoader();
    }
  };

  const handleConfirm = (type) => {
    setShow(false);
    handleReturnSubmit(type);
  };


  return (
    <div className="return-products-container card">
      <h1>Product Return</h1>

      {/* Customer Search */}
      <div className="customer-search-section mb-3 col-md-6">
        <label>Customer:</label>
        <div className="dropdown w-100">
          <input
            type="text"
            className="form-control"
            placeholder="Search customer"
            value={searchCustomerTerm}
            // onChange={(e) => setSearchCustomerTerm(e.target.value)}
            onChange={(e) => {
              setSearchCustomerTerm(e.target.value);
              if (e.target.value === '') {
                setSelectedCustomerId('');
                setSelectedCustomer(null);
                setOrders([]);
              }
            }}
            data-bs-toggle="dropdown"
          />
          <ul className="dropdown-menu w-100 p-1" style={{ maxHeight: '300px', overflowY: 'auto' }}>
            {filteredCustomers.map(c => (
              <li key={c.customer_id} onClick={() => handleCustomerChange(c.customer_id || "", c.name)}>
                <div className="card p-2 mb-1">
                  <h5 className="card-title font-14 mb-0">{c.name}</h5>
                  {c.customer_id && <p className="card-text font-13">
                    <strong>Branch:</strong> {c.branch} <br />
                    <strong>Phone:</strong> {c.phone}
                  </p>}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Customer Info */}
      {selectedCustomer && (
        <div className="customer-info mb-2">
          <h4>Order History</h4>
        </div>
      )}

      {!selectedCustomer && (
        <div className="text-center p-5 rounded-4 mt-4" style={{ background: 'rgba(59, 130, 246, 0.02)', border: '1.5px dashed rgba(59, 130, 246, 0.2)' }}>
          <i className="bi bi-search fs-2 text-blue-500 mb-2 d-block"></i>
          <h5 className="font-semibold text-slate-700">Please Select a Customer</h5>
          <p className="text-slate-400 text-sm mb-0">Choose a customer from the dropdown search list above to view their sales order history and process returns.</p>
        </div>
      )}

      {selectedCustomer && orders.length === 0 && (
        <div className="text-center p-5 rounded-4 mt-4 border border-dashed text-slate-500">
          <i className="bi bi-inbox fs-2 text-slate-300 d-block mb-2"></i>
          <h5 className="font-semibold text-slate-700">No Sales Orders</h5>
          <p className="text-slate-400 text-sm mb-0">There are no sales orders recorded for this customer in ZTR Inventory.</p>
        </div>
      )}

      {/* Product Search */}
      {orders.length > 0 && (
        <div className="product-search mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search product"
            value={productSearchTerm}
            onChange={(e) => setProductSearchTerm(e.target.value)}
          />
        </div>
      )}

      {/* Orders Table */}
      {filteredOrders.length > 0 && (
        <div className="orders-table-wrapper">
          <table className="orders-table table table-bordered">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Date</th>
                <th>Product</th>
                <th>Price (INR)</th>
                <th>Discount</th>
                <th>Credit Balance (INR)</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredOrders
                .filter(order => {
                  try {
                    const parsedSerials = JSON.parse(order.serial_number);
                    return Array.isArray(parsedSerials) && parsedSerials.length > 0;
                  } catch (e) {
                    return false;
                  }
                })
                .map(order => (
                  <tr key={order.id}>
                    <td>{order.unique_id}</td>
                    <td>{order.date}</td>
                    <td>{order.product_name}</td>
                    <td>{parseFloat(order.sales_price).toFixed(2)}</td>
                    <td>
                      {order.discount && (
                        <span>
                          {order.discount_type === "1" ? `${order.discount}%` : `${order.discount} INR`}
                        </span>
                      )}
                      {order.overall_discount && (
                        <span className="ms-1">
                          + Overall: {order.overall_discount.value} {order.overall_discount.type}
                        </span>
                      )}
                    </td>
                    <td className={order.remaining < 0 ? 'text-danger' : 'text-success'}>
                      {order.remaining ? parseFloat(order.remaining).toFixed(2) : '0.00'}
                    </td>
                    <td>
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => openReturnModal(order)}
                      >
                        Process Return
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Return Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" dialogClassName="return-modal">
        <Modal.Header closeButton>
          <Modal.Title>Return Product: {selectedProduct?.product_name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row g-3">
            {/* Available Serials */}
            <div className="col-md-6">
              <div className="card border-primary">
                <div className="card-header bg-primary text-white">
                  Available Serial Numbers ({availableSerials.length})
                </div>
                <div className="card-body" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  {availableSerials.length > 0 ? (
                    <div className="d-flex flex-wrap gap-2">
                      {availableSerials.map((serial, index) => (
                        <button
                          key={index}
                          className="btn btn-outline-primary btn-sm"
                          onClick={() => handleSerialSelect(serial)}
                        >
                          {serial.serial_number}
                        </button>
                      ))}
                    </div>
                  ) : (
                    <p className="text-muted">No serial numbers available</p>
                  )}
                </div>
              </div>
            </div>

            {/* Selected Serials */}
            <div className="col-md-6">
              <div className="card border-warning">
                <div className="card-header bg-warning text-dark">
                  Selected for Return ({selectedSerials.length})
                </div>
                <div className="card-body" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  {selectedSerials.length > 0 ? (
                    <div className="d-flex flex-wrap gap-2">
                      {selectedSerials.map((serial, index) => (
                        <button
                          key={index}
                          className="btn btn-warning btn-sm"
                          onClick={() => handleSerialRemove(serial)}
                        >
                          {serial.serial_number}
                        </button>
                      ))}
                    </div>
                  ) : (
                    <p className="text-muted">No serial numbers selected</p>
                  )}
                </div>
              </div>
            </div>

            {/* Financial Summary */}
            <div className="col-12">
              <div className="card border-info">
                <div className="card-header bg-info text-white">
                  Financial Summary
                </div>
                <div className="card-body">
                  <table className="table table-bordered">
                    <tbody>
                      {/* <tr>
                        <td colSpan="2" className="bg-light">
                          <strong>Original Prices</strong>
                        </td>
                      </tr>
                      {selectedSerials.map((serial, index) => (
                        <tr key={`original-${index}`}>
                          <td>{serial.serial_number}</td>
                          <td className="text-end">
                            {parseFloat(serial.selling_price || selectedProduct?.sales_price || 0).toFixed(2)}
                          </td>
                        </tr>
                      ))} */}

                      {false && selectedProduct?.discount && (
                        <>
                          <tr>
                            <td colSpan="2" className="bg-light">
                              <strong>Item Discounts ({selectedProduct.discount_type === "1" ? '%' : 'INR'})</strong>
                            </td>
                          </tr>
                          {selectedSerials.map((serial, index) => (
                            <tr key={`discount-${index}`}>
                              <td>{serial.serial_number}</td>
                              <td className="text-end text-danger">
                                -{serial.discount ? (
                                  selectedProduct.discount_type === "1" ?
                                    `${(parseFloat(serial.selling_price || selectedProduct?.sales_price || 0) * (parseFloat(serial.discount) / 100)).toFixed(2)} (${serial.discount}%)` :
                                    `${parseFloat(serial.discount).toFixed(2)} INR`
                                ) : '0.00'}
                              </td>
                            </tr>
                          ))}
                        </>
                      )}

                      {false && selectedProduct?.overall_discount && parseFloat(selectedProduct.overall_discount.value) > 0 && (
                        <>
                          <tr>
                            <td colSpan="2" className="bg-light">
                              <strong>Overall Discount ({selectedProduct.overall_discount.type})</strong>
                            </td>
                          </tr>
                          {selectedSerials.map((serial, index) => {
                            const basePrice = parseFloat(serial.selling_price || selectedProduct?.sales_price || 0);
                            const totalOrderValue = parseFloat(selectedProduct.price_total);
                            const itemProportion = basePrice / totalOrderValue;

                            return (
                              <tr key={`overall-${index}`}>
                                <td>{serial.serial_number}</td>
                                <td className="text-end text-danger">
                                  -{selectedProduct.overall_discount.type === "%" ?
                                    `${(basePrice * (parseFloat(selectedProduct.overall_discount.value) / 100)).toFixed(2)} (${selectedProduct.overall_discount.value}%)` :
                                    `${(parseFloat(selectedProduct.overall_discount.value) * itemProportion).toFixed(2)} INR`}
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      )}

                      <tr className="table-active">
                        <td><strong>Total Return Value</strong></td>
                        <td className="text-end">
                          <strong>{calculateReturnAmount().toFixed(2)}</strong>
                        </td>
                      </tr>

                      <tr>
                        <td><strong>Current Credit Balance</strong></td>
                        <td className="text-end text-success">
                          +{calculateDueAmount().toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Credit Adjustment</strong></td>
                        <td className="text-end text-info">
                          -{calculateFinancials().creditAdjustment.toFixed(2)}
                        </td>
                      </tr>
                      {calculateFinancials().refundAmount > 0 && (
                        <tr className="table-success">
                          <td><strong>Refund Amount</strong></td>
                          <td className="text-end text-success">
                            +{calculateFinancials().refundAmount.toFixed(2)}
                          </td>
                        </tr>
                      )}
                      <tr className="table-active">
                        <td><strong>New Credit Balance</strong></td>
                        <td className="text-end">
                          <strong>
                            {calculateFinancials().newBalance > 0 ?
                              `+${calculateFinancials().newBalance.toFixed(2)}` :
                              "0.00"}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Return Reason */}
            <div className="col-12">
              <label>Return Reason</label>
              <textarea
                className="form-control"
                value={returnReason}
                onChange={(e) => setReturnReason(e.target.value)}
                placeholder="Optional reason for return"
                rows={3}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => { setShow(true) }}
          // onClick={() => {
          //   const choice = window.confirm("Do you want to process as Immediate Refund? Click Cancel for Credit.");
          //   if (choice) {
          //     handleReturnSubmit("refund");
          //   } else {
          //     handleReturnSubmit("credit");
          //   }
          // }}

          >
            Confirm Return
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={show} onHide={() => setShow(false)} centered dialogClassName="return-modal">
        <Modal.Header closeButton>
          <Modal.Title>Confirm Return</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Do you want to process this return as an <b>Immediate Refund</b> or as <b>Credit</b>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Cancel
          </Button>
          <Button variant="success" onClick={() => handleConfirm("refund")}>
            Immediate Refund
          </Button>
          <Button variant="warning" onClick={() => handleConfirm("credit")}>
            Credit
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default Return;